<template>
  <div class="discussBoxfixPlace">
    <div class="discussBoxfix">
      <form @submit.prevent="writeDiscuss">
         <div class="discussTextAreaConfix">
           <input class="discussTextAreafix" type="text" placeholder="请输入留言" v-model="discussContent"/>
           <input type="submit" class="discussTextBtnfix" value="提交">
         </div>
     </form>
   </div>
 </div>
</template>
<script type = "text/ecamscript-6">
import { Toast } from 'mint-ui';
import {addScore} from '../../../common/js/common.js'
export default {
  name:"message",
  props:['goodID','openID','getDiscuss'],
  data(){
    return{
      discussContent:"",
      lastDicuss:"",
      parentDiscussID:0
    }
  },
  methods:{
    writeDiscuss(){//写评论
      if(this.discussContent.replace(/(^\s*)|(\s*$)/g, "").length > 0){
        if(this.lastDiscuss == this.discussContent){
          Toast({
            message: '不要灌水哟。'
          })
        }
        else{

          this.$ajax.autoService.
            login('api/addGiftDiscuss.php?content='+this.discussContent+"&goodid="+this.goodID+"&openid="+this.openID+"&parentDiscussID="+this.parentDiscussID).then((res)=>{
              this.lastDiscuss = this.discussContent;
              this.discussContent = "";
              this.getDiscuss(1,1,100)
              if (this.parentDiscussID == 0 && (this.sendtoopenid != this.openID)) {
              addScore('评论', this.openID, function (score) {
              }, function (eventName, maxTimesOneDay) {

              })
              // app.sendNewMessageTempleteMessage(that.data.sendtoopenid, '您在粉券圈中晒的贴子有了新评论了，点击即可回复', discussContent, 'pages/gift/gift?id=' + that.data.goodid)

             }
            //else if (that.data.parentDiscussID != 0 && (that.data.sendtoopenid != that.data.userOpenid)) {
            //   console.log('sendRelayMessageTempleteMessage')
            //   app.addScore('回复', wx.getStorageSync('openid'), function (score) {
            //     that.setData({
            //       couponCoin: score
            //     })
            //     that.absorbSun()
            //   }, function (eventName, maxTimesOneDay) {
            //     app.showNotGetScore(eventName, maxTimesOneDay)
            //   })
            //   app.sendRelayMessageTempleteMessage(that.data.sendtoopenid, '您在券币商城中评论有新回复了。点击即可查看', that.data.parentDiscussContent, discussContent, 'pages/gift/gift?id=' + that.data.goodid)
            // }
            })
        }
      }
    }
  }
}

</script>
<style  lang="stylus">
.discussBoxfixPlace
  width: 100%
  height:105px
  .discussBoxfix
    width: 100%
    position: fixed
    bottom: 110px
    left: 0px
    background: #f3f3f3
    padding: 15px 20px
    border-top: 1px solid #e5e5e5
    /*px*/
    box-sizing: border-box
    z-index: 100
    .discussTextAreaConfix
      width: 100%
      display: flex
      justify-content: space-between
      .discussTextAreafix
        width: 570px
        height: 72px
        border: 1px solid #ddd
        /*px*/
        background: #fff
        box-sizing: border-box
        font-size: 28px
        color: #ccc
        border-radius: 36px
        padding-left: 36px
        outline:none
        z-index: 100
      .discussTextBtnfix
        width: 120px
        height: 72px
        background: #ffc334
        color: #fff
        font-size: 28px
        border-radius: 10px
        font-size:28px
        display:inline-block
        text-align:center
        line-height:72px
        border:0px
  .mint-toast-text
    font-size:28px
  </style>



// WEBPACK FOOTER //
// src/components/userCenter/mall/message.vue